import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery, Util, Button } from '@grandvisionhq/common';
import { Container, Heading, Text } from '@grandvisionhq/elements';

// height of image is currently depending on viewport 🤷‍♂️
/* ideally image should have a specific aspect ratio and be 100% width,
the container would constrain it and height would be based on aspect ratio
as a result..  */ const BlogHeroDesktop = ({ title , summary , link , readMoreLabel , imageUrl ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: "blog-hero",
        style: Util.createCssImageSetStyle(imageUrl, 1920, {
            fit: 'fillmax'
        }, {
            extraPixelDensities: [
                2
            ],
            style: {
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }
        })
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "site-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "blog-hero__content"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "large",
        className: "blog-hero__title"
    }, title), summary && /*#__PURE__*/ React.createElement(Text, {
        className: "blog-hero__intro"
    }, Util.truncateString(summary, 150)), /*#__PURE__*/ React.createElement(Button, {
        size: "medium",
        href: link,
        className: "blog-hero__button",
        variant: "outline",
        caption: readMoreLabel,
        "aria-label": readMoreLabel
    }))))
;
// height of image depending on content
/* ideally... same comment as above.. */ const BlogHeroMobile = ({ imageUrl , title , summary , link , readMoreLabel ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: "blog-hero-mobile",
        style: Util.createCssImageSetStyle(imageUrl !== null && imageUrl !== void 0 ? imageUrl : '', 1024, {
            fit: 'fillmax'
        }, {
            extraPixelDensities: [
                2
            ],
            style: {
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "blog-hero-mobile__content"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        className: "blog-hero-mobile__title"
    }, title), summary && /*#__PURE__*/ React.createElement(Text, {
        className: "blog-hero-mobile__intro"
    }, summary), /*#__PURE__*/ React.createElement(Button, {
        size: "medium",
        href: link,
        className: "blog-hero-mobile__button",
        variant: "outline",
        caption: readMoreLabel,
        "aria-label": readMoreLabel
    })))
;
var BlogHero = (_param)=>{
    var { mobileImage , image  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "mobileImage",
        "image"
    ]);
    /* We currently use the same image for both the mobile and desktop version, if in the future
    we have a different image for mobile, we should use the same component for both mobile
    and desktop, the aspect ratio of the mobile image will facilitate more space for the
    content so for example if desktop image is 16:9 mobile could be 9:16 */ const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var ref;
    const imageUrl = isSmallScreen && mobileImage ? mobileImage.url : (ref = image === null || image === void 0 ? void 0 : image.url) !== null && ref !== void 0 ? ref : '';
    if (isSmallScreen) {
        return /*#__PURE__*/ React.createElement(BlogHeroMobile, swcHelpers.extends({}, rest, {
            imageUrl: imageUrl
        }));
    }
    return /*#__PURE__*/ React.createElement(BlogHeroDesktop, swcHelpers.extends({}, rest, {
        imageUrl: imageUrl
    }));
};
var BlogHero$1 = /*#__PURE__*/ React.memo(BlogHero);

export { BlogHero, BlogHero$1 as default };
//# sourceMappingURL=BlogHero.js.map
